import { isURL } from 'validator'

export const isUrlValid = (providedUrl: string) => {
  const isProvidedUrlValid = isURL(providedUrl, { require_tld: true, require_protocol: true })
  const isProvidedUrlValidWithHttps = isURL(`https://${providedUrl}`, { require_tld: true, require_protocol: true })

  let isValid = isProvidedUrlValid || isProvidedUrlValidWithHttps || providedUrl.length === 0

  let errorMessage = !isValid ? 'Please enter a valid URL' : undefined
  if (!isValid || providedUrl.length === 0) {
    return { isValid, errorMessage }
  }

  return { isValid: true, errorMessage: undefined }
}
